import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenavContent } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AppStateService } from '../../common/services/app-state/app-state.service';
import { fadeAnimation } from '../../../animations/animations';
import { ContextButtonService } from '../../common/services/context-button/context-button.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    animations: [
        fadeAnimation,
    ],
})
export class ShellComponent implements OnInit {
    @ViewChild('content', {static: true}) public content: MatSidenavContent;

    mode: string;

    constructor(
        public appStateService: AppStateService,
        private router: Router,
        public contextButtonService: ContextButtonService,
    ) {
    }

    public ngOnInit() {
        this.setMode();
        this.setSideNavOpenStatus();
    }

    public isLogin() {
        return this.router.url === '/login';
    }

    private setSideNavOpenStatus() {
        this.appStateService.isSideNavOpened = this.appStateService.isDesktop;
    }

    private setMode() {
        this.mode = this.appStateService.isDesktop ? 'side' : 'over';
    }
}
